module.exports = __webpack_public_path__ + "static/img/logo.327f86f2.svg";